module.exports = __webpack_public_path__ + "media/bootstrap-icons/safe2-a2c5ed2c.svg";